/** Read the banned account's label the backend attaches to `cpm_account_disqualified`. */
export function getAccountDisqualificationLabel(error: unknown): string {
  if (!error || typeof error !== 'object' || !('graphQLErrors' in error)) return '';
  if (!Array.isArray(error.graphQLErrors)) return '';
  const entry = error.graphQLErrors.find((e) => e?.message === 'cpm_account_disqualified');
  const label: unknown = entry?.extensions?.accountLabel;
  return typeof label === 'string' ? label.slice(0, 120) : '';
}
